import {Action} from "app/types/app-types";
import { SOURCE_IMAGE_INDEX } from "shape-edit/forms/helpers";

//actions:
export const SELECT_LAYERS = 'SELECT_LAYERS'
export function selectLayers(layerIdxs: string[] = []): Action<string[]> {
    return {
        type: SELECT_LAYERS,
        payload: layerIdxs
    }
}

export const TOGGLE_SELECT_LAYER = 'TOGGLE_SELECT_LAYER'
export function toggleSelectLayer(layerIdx: string): Action<string> {
    return {
        type: TOGGLE_SELECT_LAYER,
        payload: layerIdx,
    }
}

export const TOGGLE_LOCK_LAYER = 'TOGGLE_LOCK_LAYER'
export function toggleLockLayer(layerIdx: string): Action<string> {
    return {
        type: TOGGLE_LOCK_LAYER,
        payload: layerIdx
    }
}

export const SET_SHOW_CHECKS = 'SET_SHOW_CHECKS'
export function setShowChecks(newValue: boolean): Action<boolean> {
    return {
        type: SET_SHOW_CHECKS,
        payload: newValue
    }
}

//reducers:
export function selectedLayersReducer(state: string[] = [], action: Action<any>): string[] {
    switch (action.type) {
        case SELECT_LAYERS:
            return action.payload
        case TOGGLE_SELECT_LAYER:
            let newState = [...state]
            const idx = newState.indexOf(action.payload)            
            if (idx === -1) {
                if (action.payload !== SOURCE_IMAGE_INDEX) {    //do not toggle source image!!!
                    newState.push(action.payload)
                }
            } else {
                newState.splice(idx, 1)
            }
            return  newState
        default:
            return state
    }
}

export function lockedLayersReducer(state: string[] = [], action: Action<any>): string[] {
    switch (action.type) {
        case TOGGLE_LOCK_LAYER:
            let newState = [...state]
            const idx = newState.indexOf(action.payload)
            if (idx === -1) {
                newState.push(action.payload)
            } else {
                newState.splice(idx, 1)
            }
            return  newState
        default:
            return state
    }
}

export function showChecksReducer(value: boolean = true, action: Action<any>): boolean {
    switch (action.type) {
        case SET_SHOW_CHECKS:
            return  action.payload
        default:
            return value
    }
}